import { DOCTYPES } from '@/constants/doctypes'
import { createDoctypeRoutes } from '@/routers/routes/createDoctypeRoutes'

const {
  create: routeTagCreate,
  detail: routeTagDetail,
  home: routeTagHome,
  root: routeTagRoot,
} = createDoctypeRoutes({
  createName: 'new-tag',
  createPath: 'new-tag',
  detailName: 'tagDetail',
  doctype: DOCTYPES.TAG,
  homeName: 'tag-home',
  path: 'tag',
  views: {
    create: async () => await import('@/components/viewsExternal/settings/tags/AddTag.vue'),
    detail: async () => await import('@/components/viewsExternal/settings/tags/ViewTag.vue'),
    list: async () => await import('@/components/viewsExternal/settings/tags/TagView.vue'),
  },
})

export { routeTagCreate, routeTagDetail, routeTagHome, routeTagRoot }
